import moment from 'moment';

import { IDashboardAppsState } from './apps';
import { IDashboardCarriersSection } from './carriers';
import { IDashboardExceptionsState } from './exceptions';
import { IDashboardGeneralState } from './general';
import { IDashboardRange } from './range';
import { IDashboardSpecialFeaturesSection } from './special-features';

const dashboardFeatureKey = 'dashboard';

interface IDashboardState {
  range: IDashboardRange;
  general: IDashboardGeneralState;
  exceptions: IDashboardExceptionsState;
  specialFeatures: IDashboardSpecialFeaturesSection;
  apps: IDashboardAppsState;
  carriers: IDashboardCarriersSection;
}

interface IState {
  [dashboardFeatureKey]: IDashboardState;
}

const DEFAULT_VALUE = 'N/A';
const COMING_SOON = 'Coming Soon!';

const initialState: IDashboardState = {
  range: {
    startDateValue: moment().valueOf(),
    endDateValue: moment().valueOf(),
    isReset: true,
    isLoading: true,
  },
  general: {
    orders: {
      amount: DEFAULT_VALUE,
      percentage: null,
      inc: null,
    },
    deliveries: {
      amount: DEFAULT_VALUE,
      percentage: null,
      inc: null,
    },
    batches: {
      amount: DEFAULT_VALUE,
      percentage: null,
      inc: null,
    },
    carriers: {
      amount: DEFAULT_VALUE,
      percentage: null,
      inc: null,
    },
    activeUsers: {
      amount: DEFAULT_VALUE,
      percentage: null,
      inc: null,
    },
    averageClickToDoorTime: {
      amount: DEFAULT_VALUE,
      percentage: null,
      inc: null,
    },
  },
  exceptions: {
    address: {
      amount: COMING_SOON,
      percentage: null,
      inc: null,
    },
    phone: {
      amount: COMING_SOON,
      percentage: null,
      inc: null,
    },
    fraud: {
      amount: COMING_SOON,
      percentage: null,
      inc: null,
    },
    measurements: {
      amount: COMING_SOON,
      percentage: null,
      inc: null,
    },
  },
  specialFeatures: {
    isShelfReportActive: false,
    specialLabel: {
      isSpecialLabelActive: false,
      options: {
        hasGovina: false,
        hasGreetingCard: false,
        hasNoItems: false,
        hasNote: false,
        hasReturnNode: false,
      },
    },
    isScanOrdersActive: false,
    scansForFulfillmentAmount: DEFAULT_VALUE,
    lateCarrierSlaOrders: null,
    lateDeliveryPromiseOrders: null,
  },
  apps: {
    isCheckoutAppActive: false,
    isSlackWebhookActive: false,
    deliveryMethodsList: [],
  },
  carriers: {
    activeCarriersAndTotalShipmentsList: [],
  },
};

export { IState, initialState, dashboardFeatureKey as featureKey, IDashboardState };
